// the import attribute lets Node's ESM loader (e.g. Playwright's seed
// process) load this module; bundlers accept it too
import FEATURE_FLAG_DEFAULTS from "./defaults.json" with { type: "json" };

export { FEATURE_FLAG_DEFAULTS };

export type TFeatureFlags = typeof FEATURE_FLAG_DEFAULTS;
export type FeatureFlag = keyof TFeatureFlags;

const FEATURE_FLAGS = Object.keys(FEATURE_FLAG_DEFAULTS);
export const isFeatureFlag = (key: string): key is FeatureFlag =>
  FEATURE_FLAGS.includes(key);
